module.exports = __webpack_public_path__ + "static/images/gift-4.73ebae2.png";